module.exports = __webpack_public_path__ + "static/media/createAR.d341b1e3.png";